<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title">
                    <div v-if="isTalkgroup">
                        <span v-if="record.type == Const.TALK_RECORD_VOICE" v-t="'message.title_detail_of_group_talk'">
                        </span>
                        <span v-else-if="record.type == Const.TALK_RECORD_TEXT"
                              v-t="'message.title_detail_of_group_text'">
                        </span>
                        <span v-else-if="isVideo(record.type, record.data)" v-t="'message.title_detail_of_group_video'">
                        </span>
                        <span v-else-if="isImage(record.type, record.data)" v-t="'message.title_detail_of_group_image'">
                        </span>
                        <span v-else-if="isPDF(record.type, record.data)"
                              v-t="'message.title_detail_of_group_pdf'">
                        </span>
                        <span v-else v-t="'message.title_detail_of_group_melody_stamp'">
                        </span>
                    </div>
                    <div v-else v-t="'message.title_detail_of_individual_talk'">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <div v-if="isOwnTalkRecord" class="hidden">
                        <!-- 表示非表示切り替えスイッチ -->
                        <table>
                            <tr class="itemrecord">
                                <td class="hiddeninfo-name" v-t="'message.item_hide'"></td>
                                <td class="hiddeninfo-value">
                                    <el-switch v-model="hidden" active-color="#5171cb"
                                               @change="updateHiddenFlag()"></el-switch>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="player">
                        <!-- プレイヤー -->
                        <table v-if="record.type == Const.TALK_RECORD_VOICE">
                            <td>
                                <button class="play-button" style="width:80px" type="button"
                                        v-on:click="clickPlay(talkrecord, $event)">
                                    <img :src="playstopicon"><span v-t="'message.action_talk_play'"></span></img>
                                </button>
                            </td>
                            <td>
                                <div class="play-duration">
                                    <input v-model="playTime" readonly="readonly"
                                           style="background: transparent;border:none;width:60px;"></input>
                                </div>
                            </td>
                            <td>
                                <div class="play-slider">
                                    <el-slider v-model="seekPosition" :show-tooltip="false"
                                               @change="handleSliderChange"></el-slider>
                                </div>
                            </td>
                        </table>
                    </div>
                    <div class="recordinfo">
                        <!---- 音声データ ----->
                        <table v-if="record.type == Const.TALK_RECORD_VOICE">
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_talk_start_datetime'"></td>
                                <td class="recordinfo-value">{{ record.startTime.toLocaleString() }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_talk_time'"></td>
                                <td class="recordinfo-value">{{ convertMillsec(record.duration) }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_talk_talker'"></td>
                                <td class="recordinfo-value">{{ record.displayName }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_talk_language'"></td>
                                <td class="recordinfo-value">{{ originalLanguage }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" class="recordinfo-name" v-t="'message.item_talk_text'"></td>
                            </tr>
                            <tr v-if="record.data != null" class="itemrecord" style="border-bottom:none">
                                <td colspan="2" class="recordinfo-text" style="word-break: break-all;">{{ record.data
                                    }}
                                </td>
                            </tr>
                            <tr v-else class="itemrecord" style="border-bottom:none">
                                <td colspan="2" class="recordinfo-text" v-t="'message.info_no_text_data'"></td>
                            </tr>
                        </table>
                        <!---- ライブキャスト ----->
                        <table v-else-if="isVideo(record.type, record.data)">
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_live_cast_start_datetime'">
                                </td>
                                <td class="recordinfo-value">{{ record.startTime.toLocaleString() }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_live_cast_duration'"></td>
                                <td class="recordinfo-value">{{ convertMillsec(record.duration) }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_video_distributor'"></td>
                                <td class="recordinfo-value">{{ record.displayName }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_talk_distributor_language'"></td>
                                <td class="recordinfo-value">{{ originalLanguage }}</td>
                            </tr>
                            <tr v-if="videoMergedState !== VIDEO_MERGED_STATE_NO_AUDIO" class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_talk_video_merged'"></td>
                                <td class="recordinfo-value" v-if="videoMergedState === VIDEO_MERGED_STATE_COMPLETED"
                                    v-t="'message.item_talk_video_merged_done'"></td>
                                <td class="recordinfo-value" v-if="videoMergedState === VIDEO_MERGED_STATE_PROCESSING"
                                    v-t="'message.item_talk_video_merged_processing'"></td>
                                <td class="recordinfo-value" v-if="videoMergedState === VIDEO_MERGED_STATE_FAILED"
                                    v-t="'message.item_talk_video_merged_failed'"></td>
                            </tr>
                            <tr class="itemrecord-bottom" style="height: 0"/>
                        </table>
                        <!---- 画像 ----->
                        <table v-else-if="isImage(record.type, record.data)">
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_data_send_datetime'">
                                </td>
                                <td class="recordinfo-value">{{ record.startTime.toLocaleString() }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_video_distributor'"></td>
                                <td class="recordinfo-value">{{ record.displayName }}</td>
                            </tr>
                            <tr class="itemrecord-bottom">
                                <td class="recordinfo-name" v-t="'message.item_talk_distributor_language'"></td>
                                <td class="recordinfo-value">{{ originalLanguage }}</td>
                            </tr>
                        </table>
                        <table v-if="isPDF(record.type, record.data)">
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_data_send_datetime'">
                                </td>
                                <td class="recordinfo-value">{{ record.startTime.toLocaleString() }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_data_sender'"></td>
                                <td class="recordinfo-value">{{ record.displayName }}</td>
                            </tr>
                        </table>
                        <!---- text / onload data ----->
                        <table
                            v-else-if="(record.type == Const.TALK_RECORD_TEXT) || (record.type == Const.TALK_RECORD_ONLOAD_DATA)">
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_data_send_datetime'">
                                </td>
                                <td class="recordinfo-value">{{ record.startTime.toLocaleString() }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_data_sender'"></td>
                                <td class="recordinfo-value">{{ record.displayName }}</td>
                            </tr>
                            <tr class="itemrecord">
                                <td class="recordinfo-name" v-t="'message.item_talk_sender_language'"></td>
                                <td class="recordinfo-value">{{ originalLanguage }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" class="recordinfo-name" v-t="'message.item_data_text'"></td>
                            </tr>
                            <tr class="itemrecord" style="border-bottom:none">
                                <td colspan="2" class="recordinfo-text" style="word-break: break-all;">{{ record.data
                                    }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button @click="$emit('cancel')" v-t="'message.action_close'"></el-button>
                    <button v-if="record.type == Const.TALK_RECORD_VOICE || record.type == Const.TALK_RECORD_BINARY"
                            class="download-button" type="button" @click="downloadFile()">
                        <img src="@/assets/icon_download.svg" alt="download the data"/>
                        <span v-if="record.type == Const.TALK_RECORD_VOICE" v-t="'message.action_download_voice'"/>
                        <span v-else-if="isVideo(record.type, record.data)" v-t="'message.action_download_video'"/>
                        <span v-else-if="isPDF(record.type, record.data)"
                              v-t="'message.action_download_pdf'"/>
                        <span v-else v-t="'message.action_download_image'"/>
                    </button>
                </div>
                <audio id="record-player">
                    <source v-bind:src="playSource" type="audio/ogg"></source>
                </audio>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "../ServerApi.js";
import commonUtil from '../commonutil.js';
import constants from '../constants.js';

export default {
    data() {
        return {
            VIDEO_MERGED_STATE_NO_AUDIO: 0,
            VIDEO_MERGED_STATE_PROCESSING: 1,
            VIDEO_MERGED_STATE_COMPLETED: 2,
            VIDEO_MERGED_STATE_FAILED: 3,

            Const: {
                TALK_RECORD_VOICE: constants.TALK_RECORD_VOICE,
                TALK_RECORD_TEXT: constants.TALK_RECORD_TEXT,
                TALK_RECORD_BINARY: constants.TALK_RECORD_BINARY,
                TALK_RECORD_ONLOAD_DATA: constants.TALK_RECORD_ONLOAD_DATA,
            },
            notSupportAgent: false,
            timerValue: 100,
            audio: null,
            playTime: "00:00.00",
            seekPosition: 0,
            playstopicon: require('../../assets/icon_start.svg'),
            paused: false,
            dataLoaded: false,
            hidden: false,
            languageList: null,
            originalLanguage: "",
        };
    },
    computed: {
        videoMergedState() {
            if (this.record.data.endsWith(constants.VIDEO_WITH_AUDIO_SUFFIX_ORIGINAL)) {
                return this.VIDEO_MERGED_STATE_PROCESSING;
            }
            if (this.record.data.endsWith(constants.VIDEO_WITH_AUDIO_SUFFIX_COMPLETED)) {
                return this.VIDEO_MERGED_STATE_COMPLETED;
            }
            if (this.record.data.endsWith(constants.VIDEO_WITH_AUDIO_SUFFIX_FAILED)) {
                return this.VIDEO_MERGED_STATE_FAILED;
            }
            return this.VIDEO_MERGED_STATE_NO_AUDIO;
        },
        isOwnTalkRecord() {
            if (this.selected[0]?.data?.tenantId === undefined || this.appData?.tenantList[0]?.tenantId === undefined) {
                return false;
            }
            return this.selected[0].data.tenantId === this.appData.tenantList[0].tenantId;
        },
    },
    methods: {
        convertMillsec: function (duration) {
            return commonUtil.convertMillsec(duration);
        },
        timeoutEvent: function () {
            this.$data.playTime = commonUtil.convertMillsec(this.$data.audio.currentTime * 1000);
            this.$data.seekPosition = ((this.$data.audio.currentTime * 1000) / this.record.duration) * 100;
            if (!this.$data.audio.paused) {
                setTimeout(this.timeoutEvent, this.$data.timerValue);
            }
        },
        handleSliderChange(value) {
            var currentMillSec = (value / 100) * this.record.duration;
            this.$data.playTime = commonUtil.convertMillsec(currentMillSec);
            this.$data.audio.currentTime = currentMillSec / 1000;
        },
        updateHiddenFlag: function () {
            let endpoint;
            let input;
            if (this.isTalkgroup) {
                endpoint = '/updatetalkrecordhiddenflag';
                input = {
                    talkgroupId: this.selected[0].data.id,
                    talkrecordId: this.record.id,
                    hidden: this.hidden
                }
            } else {
                endpoint = '/updatepeertalkrecordhiddenflag';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    talkrecordId: this.record.id,
                    hidden: this.hidden
                }
            }

            let self = this;
            server.post(endpoint, input)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self, "Success", commonUtil.getMessageText(self.$i18n, "info_update_hidden_flag"));
                            self.record.hidden = !(self.record.hidden);
                            return true;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "info_no_speech_data"));
                            break;
                        case constants.STATUS_ERROR_PERMISSION_DENIED:
                            commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_update_hidden_flag"));
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "updateHiddenFlag").replace("{code}", res.data.status));
                    }
                    self.hidden = !(self.hidden);
                    return false;
                })
                .catch(function (error) {
                    self.hidden = !(self.hidden);
                    commonUtil.putExceptionErrorMessage(self, "updateHiddenFlag", error);
                });
        },
        clickPlay(talkrecord, event) {
            if (this.notSupportAgent) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_not_support_play_talk"));
                return;
            }
            if (this.$data.dataLoaded) {
                if (this.$data.paused) {
                    var timerId = setTimeout(this.timeoutEvent,this.$data.timerValue);
                    this.$data.playstopicon = require('../../assets/icon_stop.svg')
                    this.$data.audio.play();
                    this.$data.paused = false;
                    return;
                } else {
                    this.$data.audio.pause();
                    return;
                }
            }

            let self = this;
            let endpoint;
            let input;

            if (this.isTalkgroup) {
                endpoint = '/geturl';
                input = {
                    tenantId: this.selected[0].data.tenantId,
                    talkgroupId: this.selected[0].data.id,
                    recordInfoList: [
                        {id: this.record.id, type: this.record.type}
                    ],
                };
            } else {
                endpoint = '/getpeerurl';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    recordInfoList: [
                        {id: this.record.id, type: this.record.type}
                    ],
                }
            }

            server.post(endpoint, input)
                .then((res) => {
                    if (res.data.status != 0) {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_cannot_play_hidden_data"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "info_no_speech_data"));
                                break;
                            default:
                                commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "clickPlay").replace("{code}", res.data.status));
                                break;
                        }
                        return;
                    }

                    self.$data.playstopicon = require('../../assets/icon_stop.svg')
                    self.$data.dataLoaded = true;

                    // talkgroup: new specification using urlList
                    // p2p: old specification using urls
                    self.$data.audio.src = res.data.urlList[0].url;
                    self.$data.audio.play();
                    var timerId = setTimeout(this.timeoutEvent, this.$data.timerValue);

                    this.$data.audio.addEventListener("pause", function(){
                        self.$data.playstopicon = require('../../assets/icon_start.svg')
                        self.$data.paused = true;
                    }, false);
                    this.$data.audio.addEventListener("ended", function(){
                        self.$data.playstopicon = require('../../assets/icon_start.svg')
                        self.$data.paused = true;
                    }, false);
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "clickPlay", error);
                });
        },
        downloadFile: function () {
            let self = this;
            let endpoint;
            let input;

            if (this.hidden) {
                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_cannot_download_hidden_data"));
                return;
            }

            if (this.isTalkgroup) {
                endpoint = '/geturl';
                input = {
                    tenantId: this.selected[0].data.tenantId,
                    talkgroupId: this.selected[0].data.id,
                    recordInfoList: [
                        {id: this.record.id, type: this.record.type}
                    ]
                };
            } else {
                endpoint = '/getpeerurl';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    recordInfoList: [
                        {id: this.record.id, type: this.record.type}
                    ],
                }
            }
            // get s3 download url.
            server.post(endpoint, input)
                .then((res) => {
                    if (res.data.status != 0) {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_cannot_download_hidden_data"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "info_no_speech_data"));
                                break;
                            default:
                                commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "downloadFile").replace("{code}", res.data.status));
                                break;
                        }
                        return;
                    }
                    // talkgroup: new specification using urlList
                    // p2p: old specification using urls
                    let targetUrl = res.data.urlList[0].url;
                    self.saveFileToLocal(targetUrl, self.record);

                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "downloadFile", error);
                });
        },
        saveFileToLocal(downloadUrl, downloadRecord) {
            let saveFileName;

            let startDate = new Date(downloadRecord.startTime);
            let startDateTimeString = startDate.getFullYear() + ('00' + (startDate.getMonth() + 1)).slice(-2) + ('00' + startDate.getDate()).slice(-2);
            startDateTimeString += ('00' + startDate.getHours()).slice(-2) + ('00' + startDate.getMinutes()).slice(-2) + ('00' + startDate.getSeconds()).slice(-2);

            saveFileName = startDateTimeString + "_" + downloadRecord.displayName;
            if (this.record.type == constants.TALK_RECORD_VOICE) {
                saveFileName += ".ogg"
            } else {
                saveFileName += this.getExtensionOfOffloadData(this.record.type, this.record.data);
            }

            let self = this;
            server.downloadBinaryFile(downloadUrl)
                .then((res) => {
                    const blob = res.data;
                    commonUtil.downloadFile(blob, saveFileName)
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "saveFileToLocal", error);
                });
        },
        getDownloadDescription() {
            if (this.record.type == constants.TALK_RECORD_VOICE) {
                return commonUtil.getMessageText(this.$i18n, "action_download_voice");
            } else {
                return commonUtil.getMessageText(this.$i18n, "action_download_video");
            }
        },
        isVideo(type, data) {
            return commonUtil.isVideo(type, data);
        },
        isImage(type, data) {
            return commonUtil.isImage(type, data);
        },
        isPDF(type, data) {
            return commonUtil.isPDF(type, data);
        },
        getExtensionOfOffloadData(type, data) {
            if (data == null) {
                return null;
            }
            if (type != constants.TALK_RECORD_BINARY) {
                return null;
            }
            let index = data.indexOf(':');
            if (index < 0) {
                return null;
            }
            let extensionUpper = data.substr(0, index);
            return '.' + extensionUpper.toLowerCase();
        },
        getTalkrecordDetailData() {
            let self = this;
            let endpoint;
            let input;

            if (this.isTalkgroup) {
                endpoint = '/gettalkrecorddetail';
                input = {
                    tenantId: this.selected[0].data.tenantId,
                    talkgroupId: this.selected[0].data.id,
                    id: this.record.id
                };
            } else {
                endpoint = '/getpeertalkrecorddetail';
                input = {
                    userId1: this.selected[0].data.id,
                    userId2: this.selected[1].data.id,
                    id: this.record.id
                }
            }

            server.post(endpoint, input)
                .then((res) => {
                    if (res.data.status != 0) {
                        switch (res.data.status) {
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "info_no_speech_data"));
                                break;
                            default:
                                commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getTalkrecordDetailData").replace("{code}", res.data.status));
                                break;
                        }
                        return;
                    }

                    let element = self.$data.languageList.find(e => e.value == res.data.originalLanguageIndex);
                    if (element) {
                        self.$data.originalLanguage = self.$i18n.locale == "ja" ? element.description : element.description_en;
                    } else {
                        self.$data.originalLanguage = "-";
                    }
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "getTalkrecordDetailData", error);
                });
        },
    },
    created: function () {
        this.$data.audio = document.getElementById('record-player');
        this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
        this.hidden = (this.record.hidden) ? true : false;
        let userAgent = window.navigator.userAgent.toLowerCase();
        if ((userAgent.indexOf('msie') > 0) || (userAgent.indexOf('trident') > 0)) {
            this.notSupportAgent = true;
        }
        this.getTalkrecordDetailData();
    },
    props: ['record', 'selected', 'isTalkgroup', 'appData']
}
</script scoped>

<style scoped>

.el-slider {
    width: 250px !important;
}

.hidden > table {
    background-color: #ffffff;
    border-style: none;
    padding-top: 10px;
    table-layout: fixed;
    width: calc(500px - 20px - 20px);
}

.hiddeninfo-name {
    padding: 10px;
    width: 80%;
    vertical-align: top;
}

.hiddeninfo-value {
    padding: 10px;
    width: 20%;
    text-align: right;
}

.player > table {
    background-color: #f6f6f6;
    border-style: none;
}

.recordinfo > table {
    background-color: #ffffff;
    border-style: none;
    padding-top: 10px;
    table-layout: fixed;
    width: calc(500px - 20px - 20px);
}

.play-slider >>> .el-slider__button {
    width: 12px;
    height: 12px;
    background-color: #5171cb;
    border: #5171cb;
}

.recordinfo > table {
    width: 100%;
    background-color: #ffffff;
    border-style: none;
    border-collapse: collapse;
}

.recordinfo-name {
    padding: 10px;
    width: 40%;
    vertical-align: top;
}

.recordinfo-value {
    padding: 10px;
    width: 60%;
    color: #848991;
    text-align: right;
}

.recordinfo-text {
    padding: 10px;
    color: #848991;
    text-align: left;
}

.itemrecord {
    border-bottom: 1px #f6f6f6 solid;
}

.itemrecord-bottom {
    border-bottom: none;
}

.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.play-button {
    vertical-align: middle;
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #5171cb
}

.play-button img {
    padding-right: 10px;
    display: inline;
    vertical-align: middle;
    height: 25px;
}

.play-duration {
    display: inline-block;
    padding-left: 20px;
    vertical-align: middle;
}

.play-slider {
    display: inline-block;
    padding: 0 20px;
    vertical-align: middle;
}

.dialog-button-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
}

.download-button {
    display: flex;
    align-items: center;
    column-gap: 10px;
    text-align: left;
    padding: 0;
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #5171cb;
    outline: none;
}

.download-button img {
    display: inline;
    vertical-align: middle;
    height: 25px;
}
</style>
